import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import bg3 from "../../assect/images/bg/03.jpg"
import logo from "../../assect/images/logomobile.gif"
import { Oval } from 'react-loader-spinner';
import authService from "../../services/authService";

export default function AuthLogin(){
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        remember: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Check if user is already logged in, redirect to dashboard
        if (authService.isLoggedIn()) {
            navigate('/user/dashboard');
        }
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await authService.login({
                email: formData.email,
                password: formData.password
            });
            // Redirect to dashboard after successful login
            navigate('/user/dashboard');
        } catch (err) {
            setError(err.message || "Login gagal. Silakan periksa kredensial Anda.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    
    return(
        <section className="bg-home zoom-image d-flex align-items-center">
                // Start of Selection
                <div
                    className="bg-overlay image-wrap"
                    style={{
                        background: "linear-gradient(to right, #3494E6, #EC6EAD)",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                        backgroundPosition: 'center'
                    }}
                ></div>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="p-4 bg-white rounded-3 shadow-md mx-auto w-100" style={{maxWidth:'400px'}}>
                            {loading ? (
                                <div className="text-center py-4">
                                    <Oval
                                        visible={true}
                                        height="80"
                                        width="80"
                                        color="#4fa94d"
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />
                                    <p className="mt-3">Sedang masuk...</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <Link to="/"><img src={logo} className="mb-4 d-block mx-auto" alt="" style={{height:70}}/></Link>
                                    <h5 className="mb-3">Silakan masuk</h5>
                                    
                                    {error && (
                                        <div className="alert alert-danger" role="alert">
                                            {error}
                                        </div>
                                    )}
                                
                                    <div className="form-floating mb-3">
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            id="email" 
                                            name="email"
                                            value={formData.email} 
                                            onChange={handleChange} 
                                            placeholder="name@example.com"
                                            required
                                        />
                                        <label htmlFor="email">Alamat Email</label>
                                    </div>

                                    <div className="form-floating mb-3">
                                        <input 
                                            type="password" 
                                            className="form-control" 
                                            id="password" 
                                            name="password"
                                            value={formData.password} 
                                            onChange={handleChange} 
                                            placeholder="Password"
                                            required
                                        />
                                        <label htmlFor="password">Kata Sandi</label>
                                    </div>
                                
                                    <div className="d-flex justify-content-between">
                                        <div className="mb-3">
                                            <div className="form-check">
                                                <input 
                                                    className="form-check-input" 
                                                    type="checkbox" 
                                                    name="remember"
                                                    checked={formData.remember}
                                                    onChange={handleChange}
                                                    id="remember"
                                                />
                                                <label className="form-check-label text-muted" htmlFor="remember">
                                                    Ingat saya
                                                </label>
                                            </div>
                                        </div>
                                        <span className="forgot-pass text-muted mb-0">
                                            <Link to="/auth-reset-password" className="text-muted">
                                                Lupa kata sandi?
                                            </Link>
                                        </span>
                                    </div>
                    
                                    <button className="btn btn-primary w-100" type="submit">Masuk</button>

                                    <div className="col-12 text-center mt-3">
                                        <span>
                                            <span className="text-muted me-2">Belum punya akun?</span> 
                                            <Link to="/auth-signup" className="text-dark fw-medium">Daftar</Link>
                                        </span>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
       